import { Card, CardContent } from 'Assessment/src/components/ui/card';

export const RecordingInstructions = () => {
  return (
    <Card className="border-primary/20 bg-primary/5">
      <CardContent className="p-6 space-y-3">
        <h3 className="text-lg font-semibold text-primary">
          What would you say to them?
        </h3>
        <p className="text-lg text-muted-foreground leading-relaxed">
          Please open the mic and record your response. Only record the actual response—as if you're speaking to them directly.
        </p>
      </CardContent>
    </Card>
  );
};
